<!--
 * @Author: your name
 * @Date: 2021-05-20 11:07:43
 * @LastEditTime: 2021-06-04 10:54:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\components\HelloWorld.vue
-->
<template>
    <div :model="model" style="background:#FAFAFA">
        <!-- 附件 -->
        <div class="weui-cells weui-cells_form" id="uploader" v-show="showCode">
          <div class="weui-cell">
              <div class="weui-cell__bd">
              <div class="weui-uploader">
                  <div class="weui-uploader__hd">
                  <p class="weui-uploader__title">图片上传（含健康码、行程码；如14天内途径疫情中、高风险区，还需上传核酸检测报告）：</p>
                  <div class="weui-uploader__info"><span id="uploadCount">0</span>/20</div>
                  </div>
                  <div class="weui-uploader__bd">
                  <ul class="weui-uploader__files" id="uploaderFiles"></ul>
                  <div class="weui-uploader__input-box">
                      <input name="file" id="uploaderInput" class="weui-uploader__input" type="file" accept="image/*" multiple="" />
                  </div>
                  </div>
              </div>
              </div>
          </div>
          <div class="weui-btn-area">
            <button class="weui-btn weui-btn_primary" @click="uploadHealthCode"
              style="background-color: #169BD5;color:#FFFFFF">确认</button>
          </div>
        </div>
        <div class="weui-cells__title TitleClass" align="center" >被访人信息</div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell" align="left">
                <div class="weui-cell__hd" style="width:20%">
                    <label class="weui-label" prop="visitedname" style="float:left">姓名：</label>
                </div>
                <div class="weui-cell__bd" style="float:right">
                    <input v-model="model.visitedname" class="weui-input" type="text" required="required" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd" style="width:20%">
                    <label class="weui-label" align="left" prop="visitedphonenum">电话：</label>
                </div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitedphonenum" class="weui-input" type="number"  disabled placeholder="">
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd" style="width:20%">
                    <label class="weui-label" align="left" prop="visiteddeptfullname">部门：</label>
                </div>
                <div class="weui-cell__bd">
                    <input v-model="model.visiteddeptfullname" class="weui-input" type="text" style="font-size:14px" disabled placeholder="正确填写手机号后自动填充">
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells__title TitleClass" align="center">访客信息</div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">姓名：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitorname" class="weui-input" type="text" disabled placeholder="">
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">电话：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitorphonenum" class="weui-input" type="number" placeholder="" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">身份证号：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitoridcard" class="weui-input" type="text" placeholder="" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">所属单位： </label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitorcompony" class="weui-input" type="text" placeholder="" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">入园时间：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.estimateintoparktime" placeholder="时间格式2020-01-01 00:00" style="border:none;width:100%" type="primary" readonly />
                    <van-popup v-model="show" position="bottom">
                        <van-datetime-picker type="datetime" :min-date="minDate" :filter="vanDatetimePickerFilter" @confirm="saveTimeAction" @cancel="show= false" />
                    </van-popup>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">离园时间：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.estimateleavetime" placeholder="时间格式2020-01-01 00:00" style="border:none;width:100%" type="primary" readonly />
                    <van-popup v-model="show1" safe-area-inset-bottom position="bottom">
                        <van-datetime-picker type="datetime" :min-date="minDate" :filter="vanDatetimePickerFilter" @confirm="saveTimeEnd" @cancel="show1=false" />
                    </van-popup>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">来访事由：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitreason" class="weui-input" type="text" placeholder="" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">车牌号：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.carnumber" class="weui-input" type="text" placeholder="" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells__title TitleClass" align="center" v-if="lists.length > 0?true:false" >同行者信息</div>
        <div>
            <div v-for="(list) in lists" :key="list.index">
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd" style="width:20%">
                            <label class="weui-label" align="left">姓名：</label>
                        </div>
                        <div class="weui-cell__bd">
                            <input v-model="list.visitorname" class="weui-input" type="text" placeholder="" sytle="width:75%" disabled>
                        </div>
                    </div>
                    <div class="weui-cell lineHeng">
                    </div>
                </div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">电话：</label></div>
                        <div class="weui-cell__bd">
                            <input v-model="list.visitorphonenum" class="weui-input" type="number" placeholder="" disabled>
                        </div>
                    </div>
                    <div class="weui-cell lineHeng">
                    </div>
                </div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label" align="left">身份证号：</label></div>
                        <div class="weui-cell__bd">
                            <input v-model="list.visitoridcard" class="weui-input" type="text" placeholder="" disabled>
                        </div>
                    </div>
                    <div class="weui-cell lineHeng">
                    </div>
                </div>
            </div>
        </div>
        <div class="weui-cells__title TitleClass" align="center" v-show="showUpload">已上传健康码和行程码，无需重复上传</div>
    </div>
</template>

<script>
import weui from '../../static/plugins/weui.min.js'
import { getAction, postAction } from '../request/http'
import { Toast } from 'we-vue'
import $ from 'jquery'
import service from '../request/request.js'
var uploadCount = 0
var uploadCountDom = null
var uploadList = []
var sourceid
var attachmenttypeid
export default {
    name: 'HelloWorld',
    data() {
        return {
            show: false,
            show1: false,
            showCode: false,
            showUpload: true,
            minDate: new Date(),
            model: {},
            screenWidth: document.body.clientWidth, // 屏幕宽
            datalist: [],
            lists: [],
            addPartnerBackGroundColor: 'white',
            pageInfo: {
                currentPage: 1, // 当前页面
                pageSize: 10,
                totalCount: 0, // 总数
                sord: 'desc',
                sidx: 'id'
            }
        }
    },
    computed: {

    },
    beforeCreate() {
        document.title = "入园申请"
    },
    created() {
    },
    mounted() {
      var that = this
      sourceid = this.generateId()
      this.checkNode(sourceid)
      this.createmore()
      // 附件上传
      uploadCountDom = document.getElementById('uploadCount')
      weui.uploader('#uploader', {
        url: process.env.BASE_API + '/vtp/toaEnterParkApply/upload',
        // url: 'http://172.20.193.147:7000/vtp/toaEnterParkApply/upload',
        auto: false,
        type: 'file',
        fileVal: 'file',
        compress: {
          width: 1600,
          height: 1600,
          quality: 0.8
        },
        // 文件添加前的回调
        onBeforeQueued: function(files) {
          // `this` 是轮询到的文件, `files` 是所有文件
          if (['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].indexOf(this.type) < 0) {
            weui.alert('请上传图片')
            return false // 阻止文件添加
          }
          if (this.size > 10 * 1024 * 1024) {
            weui.alert('请上传不超过10M的图片')
            return false
          }
          if (files.length > 10) {
            // 防止一下子选择过多文件
            weui.alert('一次最多只能上传10张图片，请重新选择')
            return false
          }
          if (uploadCount + 1 > 20) {
            weui.alert('最多只能上传20张图片')
            return false
          }
          ++uploadCount
          uploadCountDom.innerHTML = uploadCount
          // return true; // 阻止默认行为，不插入预览图的框架
        },
        // 文件添加成功的回调
        onQueued: function() {
          // console.log(this)
          uploadList.push(this)
          // console.log(this.status); // 文件的状态：'ready', 'progress', 'success', 'fail'
          // console.log(this.base64); // 如果是base64上传，file.base64可以获得文件的base64
          this.upload() // 如果是手动上传，这里可以通过调用upload来实现；也可以用它来实现重传。
          // this.stop(); // 中断上传
          // return true; // 阻止默认行为，不显示预览图的图像
        },
        // 文件上传前调用
        onBeforeSend: function(data, headers) {
          // console.log(this)
          // console.log(headers)
          if (that.attachmenttypeid === undefined) {
            that.attachmenttypeid = ''
          }
          $.extend(data, {
            sourceid: sourceid,
            attachmenttypeid: that.attachmenttypeid,
            visitorname: that.model.visitorname,
            id: this.id
          }) // 可以扩展此对象来控制上传参数
          // $.extend(data, { filetest: tesObjs })
          // $.extend(headers, { Origin: 'http://127.0.0.1' }); // 可以扩展此对象来控制上传头部
          // return false; // 阻止文件上传
        },
        // 上传进度的回调
        onProgress: function(procent) {
          // console.log(this, procent)
          // return true; // 阻止默认行为，不使用默认的进度显示
        },
        // 上传成功的回调
        onSuccess: function(ret) {
            if (ret.status === 'true') {
                that.attachmenttypeid = ret.attachmenttypeid
                return true
            } else {
                Toast.fail(ret.message)
                return false
            }
          // return true; // 阻止默认行为，不使用默认的成功态
        },
        // 上传失败的回调
        onError: function(err) {
          // console.log(this, err)
          // return true; // 阻止默认行为，不使用默认的失败态
        }
      })
      // weui.gallery图片预览功能
      document.querySelector('#uploaderFiles').addEventListener('click', function(e) {
        var target = e.target
        while (!target.classList.contains('weui-uploader__file') && target) {
          target = target.parentNode
        }
        if (!target) return
        var url = target.getAttribute('style') || ''
        var id = target.getAttribute('data-id')
        if (url) {
          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, '')
        }
        var gallery = weui.gallery(url, {
          className: 'custom-name',
          onDelete: function onDelete() {
            weui.confirm('确定删除该图片？', function() {
              --uploadCount
              uploadCountDom.innerHTML = uploadCount
              for (var i = 0, len = uploadList.length; i < len; ++i) {
                var file = uploadList[i]
                var tempId = file.id
                if (String(tempId) === id) {
                    that.deleteFile(id, sourceid, that.model.visitorname)
                  file.stop()
                  break
                }
              }
              target.remove()
              gallery.hide()
            })
          }
        })
      })
    },
    methods: {
        uploadHealthCode(e) {
            var that = this
            if (this.showCode === true && uploadCount === 0) {
                Toast.fail('上传最新的健康码以及行程码截图')
                return false
            }
            if (uploadCount !== 0 && uploadCount < 2) {
                Toast.fail('请分别上传本人的健康码和行程码截图')
                return false
            }
            if (uploadCount !== 0 && uploadCount < 2 + 2 * this.lists.length) {
                Toast.fail('请分别上传所有人的健康码和行程码截图')
                return false
            } else {
                this.$weui.confirm('提交后将不允许再次上传，请确认是否继续', {
                    title: '注意',
                    buttons: [{
                        label: '取消',
                        type: 'primary',
                        onClick: function() { }
                    },
                    {
                        label: '确定',
                        type: 'primary',
                        onClick: function() { that.tryAttach() }
                    }]
                })
            }
        },
        checkNode(sourceid) {
            getAction("/vtp/toaEnterParkApply/checkNode", { sourceId: sourceid }).then((res) => {
                if (res.data.success) {
                    this.showUpload = false
                    this.showCode = true
                }
                if (this.showCode) {
                    this.checkDelete(sourceid)
                }
            })
        },
        checkDelete(sourceid) {
            getAction("/vtp/toaEnterParkApply/checkDelete", { sourceId: sourceid }).then((res) => {
                if (res.data.success) {

                }
            })
        },
        tryAttach() {
            postAction("/vtp/toaEnterParkApply/approvalAttach", { sourceId: this.getUrlParams("sourceid") }).then((res) => {
                let success = res.data.state
                if (success === "success") {
                    Toast.success('提交成功')
                }
                this.$router.push({
                    name: 'index',
                    params: {
                    }
                })
            })
        },
        deleteFile(index, sourceid, visitorname) {
            postAction("/vtp/toaEnterParkApply/deleteFile", { index: index, sourceid: sourceid, visitorname: visitorname }).then((res) => {
                let success = res.data.success
                if (success) {
                    Toast.success('删除成功')
                } else {
                    Toast.fail('删除失败')
                }
            })
        },
        getUrlParams(names) {
          // 获取？后面的参数
          var urlSearch = location.search
          var urlValue = ""
          // 以？*&来拆分
          var params = urlSearch.split(/[?*&]/)
            for (var i = 0; i < params.length; i++) {
            // 如果url参数里包含传递过来names字段，则取=后面的部分
                if (params[i].indexOf(names) >= 0) {
                    urlValue = params[i].split("=")[1]
                    return urlValue
                }
            }
          return urlValue
        },
        generateId() {
            return this.getUrlParams("sourceid")
        },
        vanDatetimePickerFilter(type, options) {
            if (type === 'minute') {
                return options.filter((option) => option % 10 === 0)
            }
            return options
        },
        createmore() {
          // var id = this.$route.query.sourceid
          var id = this.generateId()
          if (!id) {
              id = ''
          }
          var data = {
            qry_id: id
          }
          var partnerdata = {
            parentid: id
          }
          var that = this
          getAction("/vtp/toaEnterParkApply/list", data).then((res) => {
              if (res.data.success && res.data.result.dataList.length > 0) {
                  let entity = res.data.result.dataList[0]
                  that.model.visitedname = entity.visitedname
                  that.model.visitedphonenum = entity.visitedphonenum
                  that.model.visitorname = entity.visitorname
                  that.model.visitorphonenum = entity.visitorphonenum
                  that.model.visitoridcard = entity.visitoridcard
                  that.model.visitorcompony = entity.visitorcompony
                  that.model.visitreason = entity.visitreason
                  that.model.visiteddeptfullname = entity.visiteddeptfullname
                  that.model.carnumber = entity.carnumber
                  that.model.estimateintoparktime = entity.estimateintoparktime
                  that.model.estimateleavetime = entity.estimateleavetime
                getAction("/vtp/toaEnterParkPartner/list", partnerdata).then((res) => {
                  if (res.data.success) {
                    this.lists = res.data.result.dataList
                  }
                })
                  this.$forceUpdate()
              }
          })
        },
        timeAction(time) {
            const date = new Date(time)
            var seperator1 = "-"
            var seperator2 = ":"
            var month = date.getMonth() + 1
            var strDate = date.getDate()
            var hour = date.getHours()
            if (hour.toString().length === 1) {
                hour = '0' + hour
            }
            var minutes = date.getMinutes()
            if (minutes.toString().length === 1) {
                minutes = '0' + minutes
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate
            }
            const a =
                date.getFullYear() +
                seperator1 +
                month +
                seperator1 +
                strDate +
                " " +
                hour +
                seperator2 +
                minutes
            this.model.estimateintoparktime = a
        },
        saveTimeAction(val) {
            this.show = false
            this.timeAction(Date.parse(val))
        },
        timeFormatterEnd(time) {
            const date = new Date(time)
            var seperator1 = "-"
            var seperator2 = ":"
            var month = date.getMonth() + 1
            var strDate = date.getDate()
            var hour = date.getHours()
            var minutes = date.getMinutes()
            if (hour.toString().length === 1) {
                hour = '0' + hour
            }
            if (minutes.toString().length === 1) {
                minutes = '0' + minutes
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate
            }
            const a =
                date.getFullYear() +
                seperator1 +
                month +
                seperator1 +
                strDate +
                " " +
                hour +
                seperator2 +
                minutes
            this.model.estimateleavetime = a
        },
        saveTimeEnd(val) {
            this.show1 = false
            this.timeFormatterEnd(Date.parse(val))// 选择时间日期 2019-01-30
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#app .weui-cells_form span >>> .van-button {
    height: 100%;
}
weui-cells .link-top {
    width: 100%;
    height: 1px;
    border-top: solid #acc0d8 1px;
}
.bannercontainner {
    padding: 15px;
}
.gonggao {
    flex: 1;
    background-color: rgb(252, 104, 72);
    border-radius: 15px;
    height: 35px;
    line-height: 35px;
}
.banner {
    background-image: url('../assets/banner.jpg');
    background-size: 100% 100%;
}
.greeBack {
    background-color: green;
}
#app .weui-loading_toast >>> .weui-mask_transparent {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: #666666;
    opacity: 0.5;
}
.weui-mask_transparent {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
}
.gonggaocontent {
    flex: 4;
    height: 35px;
    text-align: left;
    line-height: 35px;
    text-indent: 15px;
}
.line {
    margin-top: 5px;
    background-color: rgb(246, 246, 246);
    height: 2px;
}
.linecontainer {
    padding-left: 10px;
    padding-right: 10px;
}
.enterParkApplyleftcontent {
    background-image: url('../assets/enterParkApply.jpg');
    background-size: 100% 100%;
    border-radius: 15px;
}
.allfunction {
    padding-top: 20px;
}
.enterParkApplyrightcontent1 {
    background-image: url('../assets/applyHistory.jpg');
    background-size: 100% 100%;
    margin-top: 10px;
    border-radius: 15px;
}
.enterParkApplyrightcontent2 {
    background-image: url('../assets/cancelApply.jpg');
    background-size: 100% 100%;
    margin-top: 10px;
    border-radius: 15px;
}
.enterParkApplycontainer {
    padding: 10px;
}
.enterParkApplyrightcontainer {
    padding-left: 0px;
    padding-right: 10px;
    padding-top: 0px;
}

#app div >>> .weui-cells::before {
    border: 0px;
}
#app div >>> .weui-cells::after {
    border: 0px;
}
#app div >>> .weui-cells {
    margin-top: 0px;
}
.lineHeng {
    margin-left: 5%;
    width: 90%;
    padding: 0px;
    border-top: 1px solid var(--weui-FG-3);
}
.TitleClass{
  background: #e7eaec;
  margin: 0 auto;
  height: 30px;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditCode.vue